"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/main/map.index.ts');
const router_1 = require("@angular/router");
const map_component_1 = require("./map.component");
const global_1 = require("../../commons/global");
const photogram_component_1 = require("./photogram/photogram.component");
const project_setting_component_1 = require("./detail-views/project-setting.component");
const guide_component_1 = require("./guide/guide.component");
const pin_component_1 = require("./detail-views/annots/pin.component");
const line_component_1 = require("./detail-views/annots/line.component");
const area_component_1 = require("./detail-views/annots/area/area.component");
const volume_component_1 = require("./detail-views/annots/volume/volume.component");
const multi_poi_component_1 = require("./detail-views/annots/multi-poi/multi-poi.component");
const agronomeye_component_1 = require("./detail-views/annots/3rd_party/agronomeye.component");
const dataum_component_1 = require("./detail-views/annots/3rd_party/dataum.component");
const image_component_1 = require("./detail-views/image/image.component");
const geojson_component_1 = require("./detail-views/layers/geojson.component");
const processing_component_1 = require("./detail-views/processing.component");
const share_component_1 = require("./detail-views/share.component");
const terrain_compare_component_1 = require("./detail-views/terrain-compare/terrain-compare.component");
const fly_to_line_component_1 = require("./detail-views/annots/fly-to-line/fly-to-line.component");
const featuer_properties_viewer_component_1 = require("./detail-views/layers/featuer-properties-viewer/featuer-properties-viewer.component");
const pp_component_1 = require("./detail-views/annots/3rd_party/pp.component");
const identify_interface_1 = require("@src/app/xs/interfaces/identify.interface");
const Routes = [
    { path: '', redirectTo: '/' + global_1.AppRoutes.MAIN_PROJECTS, pathMatch: 'full' },
    {
        path: ':projId', component: map_component_1.MapComponent,
        children: [
            { path: '', redirectTo: 'layers', pathMatch: 'full' },
            { path: 'settings', component: project_setting_component_1.ProjectSettingComponent, pathMatch: 'full' },
            { path: 'shares', component: share_component_1.ShareComponent, pathMatch: 'full' },
            // annotation editors:
            { path: 'datum/:id', component: dataum_component_1.DatumViewer, pathMatch: 'full' },
            { path: 'agronomeye/:id', component: agronomeye_component_1.AgronoViewer, pathMatch: 'full' },
            { path: 'pp/:id', component: pp_component_1.PPViewer, pathMatch: 'full' },
            { path: 'proc/:type/:id', component: processing_component_1.ProcessingDetailsComponent, pathMatch: 'full' },
            { path: 'proc/:type/:id/:jid', component: processing_component_1.ProcessingDetailsComponent, pathMatch: 'full' },
            { path: 'image/:id', component: image_component_1.ImageViewer, pathMatch: 'full' },
            { path: 'poi/:id', component: pin_component_1.PinViewer, pathMatch: 'full' },
            { path: 'line/:id', component: line_component_1.LineViewer, pathMatch: 'full' },
            { path: 'area/:id', component: area_component_1.AreaComponent, pathMatch: 'full' },
            { path: 'volume/:id', component: volume_component_1.VolumeComponent, pathMatch: 'full' },
            { path: 'multiPoi/:id', component: multi_poi_component_1.MultiPoiComponent, pathMatch: 'full' },
            { path: 'flyToLine/:id', component: fly_to_line_component_1.FlyToLineComponent, pathMatch: 'full' },
            { path: 'geojson/:lat/:lng', component: geojson_component_1.GeoJsonViewer, pathMatch: 'full' },
            { path: 'featureProperties', component: featuer_properties_viewer_component_1.FeatuerPropertiesViewerComponent, pathMatch: 'full' },
            // {path: 'images', component: ImageManager, pathMatch: 'full'},
            // {path: 'search', component: ProjectInpectComponent, pathMatch: 'full'},
            // {path: 'search/:annotId', component: ProjectInpectComponent, pathMatch: 'full'},
            // {path: 'layers', component: LayermanComponent, pathMatch: 'full'},
            { path: 'guide/:id', component: guide_component_1.GuideComponent, pathMatch: 'full' },
            { path: 'photogram', component: photogram_component_1.PhotogramComponent, pathMatch: 'full' },
            { path: 'terrainCompare/:transformId', component: terrain_compare_component_1.TerrainCompareComponent, pathMatch: 'full' },
            //{path: 'setting', component: ProjectSettingComponent, pathMatch: 'full'},
            { path: ':tabId', component: map_component_1.TBAComponent, pathMatch: 'full' },
            { path: '**', component: map_component_1.TBAComponent }
        ]
    }
];
DEBUG_1.DEBUG.log('/app/main/map.index.ts', 'module');
class MapModule {
    constructor() {
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
}
exports.MapModule = MapModule;
